module.exports = __webpack_public_path__ + "media/images/team_member/member_3-e2b16fc59a4067e11d94ab91e22a933e.jpg";